import axios from "core/network/interceptor";
import { Candidate } from "core/board/interface";
import { GetDashboardUrl } from "./constants";

export type GetDashboardResponse = {
  stats: {
    title: string;
    value: number;
    diff: number;
  }[];
  last_candidates: Candidate[];
  last_applications: {
    id: number;
    created_at: number;
    applications_count: number;
    offer_id: number;
    job_title: string;
    job_type: string;
    candidate: Candidate;
   }[];
  yearly_stats: {
    new_candidates_count_per_month: number[];
    synced_candidates_count_per_month: number[];
    average_processing_time_per_month: number[];
  };
  /** Only on /admin/api/dashboard/global */
  network?: {
    totals: {
      agencies_count: number;
      agents_count: number;
      temp_workers_count: number;
      synced_temp_workers_count: number;
      offers_count: number;
      applications_count: number;
      window_days: number;
    };
    agencies: NetworkAgency[];
  };
};

export type NetworkAgency = {
  id: number;
  name: string;
  temp_workers: number;
  synced_temp_workers: number;
  new_temp_workers: number;
  offers: number;
  applications: number;
  agents: number;
};

export const GetDashboard =
  async (url = GetDashboardUrl): Promise<GetDashboardResponse> => {
    const response = await axios.get(url);
    return response.data;
  };
